import { useEffect, useRef } from "react";

const TurnstileWidget = ({ onToken, sitekey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY, style }) => {
    const containerRef = useRef(null);
    const widgetIdRef = useRef(null);
    const onTokenRef = useRef(onToken);

    useEffect(() => { onTokenRef.current = onToken; }, [onToken]);

    useEffect(() => {
        const renderWidget = () => {
            if (!containerRef.current || !window.turnstile) return;
            widgetIdRef.current = window.turnstile.render(containerRef.current, {
                sitekey,
                callback: (token) => onTokenRef.current(token),
                'expired-callback': () => onTokenRef.current(null),
                'error-callback': () => onTokenRef.current(null),
            });
        };

        const cleanup = () => {
            if (widgetIdRef.current && window.turnstile) {
                window.turnstile.remove(widgetIdRef.current);
                widgetIdRef.current = null;
            }
        };

        if (window.turnstile) {
            renderWidget();
            return cleanup;
        }
        const script = document.querySelector('script[src*="challenges.cloudflare.com/turnstile"]');
        if (script) {
            script.addEventListener('load', renderWidget);
            return () => {
                script.removeEventListener('load', renderWidget);
                cleanup();
            };
        }
    }, [sitekey]);

    if (!sitekey) return null;

    return <div ref={containerRef} style={style} />;
};

export default TurnstileWidget;
